import {
  HouseNightlyTripIndividual,
  HouseNightlyTripIndividualDto,
} from '../../../../../../../lib/graphql'
import {
  divideByFactor,
  multiplyByFactor,
} from '../../../../../../../utils/prices'

const computeInputPrice = (value: undefined | null | string | number) => {
  return value === '' || value === null || value === undefined
    ? null
    : multiplyByFactor(value)
}

export const computeHouseNightlyTripIndividualInputs = ({
  isEnabled,
  options,
}: HouseNightlyTripIndividualDto): HouseNightlyTripIndividualDto => {
  const computedInputs: HouseNightlyTripIndividualDto = {
    isEnabled,
    options: {
      seasonalPrices: [
        {
          endAt: options.seasonalPrices[0].endAt,
          startAt: options.seasonalPrices[0].startAt,
          sharedBedroom: {
            highPrice: computeInputPrice(
              options.seasonalPrices[0].sharedBedroom.highPrice,
            ),
            lowPrice: computeInputPrice(
              options.seasonalPrices[0].sharedBedroom.lowPrice,
            ),
            mediumPrice: computeInputPrice(
              options.seasonalPrices[0].sharedBedroom.mediumPrice,
            ),
          },
          singleBedroom: {
            highPrice: computeInputPrice(
              options.seasonalPrices[0].singleBedroom.highPrice,
            ),
            lowPrice: computeInputPrice(
              options.seasonalPrices[0].singleBedroom.lowPrice,
            ),
            mediumPrice: computeInputPrice(
              options.seasonalPrices[0].singleBedroom.mediumPrice,
            ),
          },
        },
      ],
      vatRate: options.vatRate,
      touristTaxPrice: computeInputPrice(options.touristTaxPrice),
    },
  }

  return computedInputs
}

const computeDefaultValuePrice = (value: undefined | null | number) => {
  return value === null || value === undefined ? null : divideByFactor(value)
}

export const computeHouseNightlyTripIndividualDefaultValues = ({
  isEnabled,
  options,
}: HouseNightlyTripIndividual): HouseNightlyTripIndividualDto => {
  const computedInputs: HouseNightlyTripIndividualDto = {
    isEnabled,
    options: options
      ? {
          seasonalPrices: [
            {
              endAt: options.seasonalPrices[0].endAt,
              startAt: options.seasonalPrices[0].startAt,
              sharedBedroom: {
                highPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].sharedBedroom.highPrice,
                ),
                lowPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].sharedBedroom.lowPrice,
                ),
                mediumPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].sharedBedroom.mediumPrice,
                ),
              },
              singleBedroom: {
                highPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].singleBedroom.highPrice,
                ),
                lowPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].singleBedroom.lowPrice,
                ),
                mediumPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].singleBedroom.mediumPrice,
                ),
              },
            },
          ],
          vatRate: options.vatRate,
          touristTaxPrice: computeDefaultValuePrice(options.touristTaxPrice),
        }
      : {
          seasonalPrices: [
            {
              endAt: null,
              startAt: null,
              sharedBedroom: {
                highPrice: null,
                lowPrice: null,
                mediumPrice: null,
              },
              singleBedroom: {
                highPrice: null,
                lowPrice: null,
                mediumPrice: null,
              },
            },
          ],
          vatRate: null,
          touristTaxPrice: null,
        },
  }

  return computedInputs
}
